
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { AuthService } from '../services/auth.service';
import { ConfigService } from '../services/config.service';
import { CustomSnackBarService } from '../services/custom-snack-bar.service';
import { GlobalVariablesService } from '../services/global-variables.service';
import { MenuItemButton } from '../models/menu-item-button';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackBar: CustomSnackBarService,
    private globalVariables: GlobalVariablesService,
    private configService: ConfigService,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.authService.isLoggedIn.pipe(
      take(1),

      map((isLoggedIn: boolean) => {
        if (!isLoggedIn && next.routeConfig != null) {
          this.authService.logout();
          return false;
        }

        const link = state.url.split(/[?#]/, 1)[0].replace(/^\//, "");
        const menuItems = this.authService.retornaEstruturaMenu();

        if (!menuItems) {
          if (this.isRotaInicial(link)) {
            return true;
          }

          this.router.navigate([this.retornaRotaInicial()]);
          return false;
        }

        const menuItemButton: MenuItemButton | undefined = this.verificaEstruturaMenu(menuItems, link);

        if (!menuItemButton && !this.isRotaLivre(link)) {
          this.snackBar.openSnackBar(
            "Você Não Tem Permissão de Acesso a Esta Página",
            null,
            "Warn"
          );
          // this.authService.logout();
          return false;
        }

        if (menuItemButton) {
          this.globalVariables.telaAtiva = menuItemButton.label;
          this.globalVariables.telaDetalheAtiva = "";
        }

        return true;
      })
    );
  }

  private verificaEstruturaMenu(menuItems: any[], link: string | undefined ): MenuItemButton | undefined {

    if (menuItems === undefined) {
      return undefined;
    }
    let menuItemButton = menuItems.find(menuItem => this.isRoute(menuItem.link, link)) as MenuItemButton | undefined;

    if (menuItemButton !== undefined) {
      return menuItemButton;
    }

    for (const element of menuItems) {
      if (element.items === undefined) {
        continue;
      }

      menuItemButton = this.verificaEstruturaMenu(element.items, link);

      if (menuItemButton !== undefined) {
        return menuItemButton;
      }
    }
    return undefined;
  }

  private isRoute(menuLink: string | undefined, link: string | undefined): boolean {
    return !!menuLink && !!link && (link === menuLink || link.startsWith(`${menuLink}/`));
  }

  private isRotaLivre(link: string | undefined): boolean {
    return !link || ["home", "portal", "muda-senha", "nova-senha"].includes(link);
  }

  private retornaRotaInicial(): string {
    return ConfigService.settings.app.id === "gp" ? "/portal" : "/home";
  }

  private isRotaInicial(link: string | undefined): boolean {
    return link === this.retornaRotaInicial().substring(1);
  }
}
